export default __webpack_public_path__ + "9f965b8f2264a62ef6136de900b46cc2.png";